/**
 * TODO: move this to build process as a back-fill for "addressLines"
 *
 * addresses are in format "STREET_ADDRESS, CITY, STATE_CODE ZIP_CODE"
 * where STREET_ADDRESS can contain ","
 * */

/** @param {string} address */
export function stripCityStateZip(address) {
  const splitAddress = address.split(',');
  const streetAddressOnly = splitAddress.slice(0, -2).join(',');
  // just in case we are wrong about the address format
  return streetAddressOnly.length ? streetAddressOnly : address;
}

/** @param {string} address */
export function stripAddress(address) {
  const splitAddress = address.split(',');
  return splitAddress.slice(-2).join(',').trim();
}

/** @param {FF.Location} location */
export function getFormattedAddress(location) {
  return location.operationConfigs.addressLines
    ? `${location.operationConfigs.addressLines.addressLine1}${
        location.operationConfigs.addressLines.addressLine2
          ? `, ${location.operationConfigs.addressLines.addressLine2}`
          : ''
      }`
    : stripCityStateZip(location.operationConfigs.address);
}

/** @param {FF.Location} location */
export function getFormattedCityStateZip(location) {
  return location.operationConfigs.addressLines
    ? `${location.operationConfigs.addressLines.city}, ${location.operationConfigs.addressLines.stateCode} ${location.operationConfigs.addressLines.zipCode}`
    : stripAddress(location.operationConfigs.address);
}
